import React from 'react';

const DeleteIcon = (props) => {
    return (
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve" width="25px" height="25px" style={{cursor:"pointer"}}>
   <g>
       <circle fill="#099AA4" cx="256" cy="256" r="256"/>
       <g>
           <circle fill="#099AA4" cx="256" cy="256" r="220.69"/>
           <path fill="#099AA4" d="M150.069,397.241l-56.585,56.585c-12.89-10.594-24.716-22.42-35.31-35.31l56.585-56.585v17.655
               c0.029,9.739,7.916,17.626,17.655,17.655H150.069z"/>
           <path fill="#099AA4" d="M453.826,93.484l-25.247,25.247l-31.338,31.338v-17.655c-0.028-9.739-7.916-17.627-17.655-17.655
               h-17.655l31.338-31.338l25.247-25.247C431.406,68.768,443.232,80.594,453.826,93.484z"/>
           <path fill="#099AA4" d="M453.826,418.516c-10.594,12.89-22.42,24.716-35.31,35.31l-56.585-56.585h17.655
               c9.739-0.029,17.626-7.916,17.655-17.655v-17.655L453.826,418.516z"/>
           <path fill="#099AA4" d="M150.069,114.759h-17.655c-9.739,0.028-17.627,7.916-17.655,17.655v17.655l-31.338-31.338
               L58.174,93.484c10.594-12.89,22.421-24.716,35.31-35.31l25.247,25.247L150.069,114.759z"/>
       </g>
       <path fill="#099AA4" d="M256,88.276L256,88.276c92.632,0,167.724,75.093,167.724,167.724l0,0
           c0,92.632-75.093,167.724-167.724,167.724l0,0c-92.632,0-167.724-75.093-167.724-167.724l0,0
           C88.276,163.368,163.368,88.276,256,88.276z"/>
       <g>
           <path fill="#FFFFFF" d="M256,353.103c-43.949-0.004-82.418-29.523-93.795-71.975s7.176-87.252,45.234-109.232
               c4.218-2.443,9.618-1.003,12.061,3.215c2.443,4.218,1.003,9.618-3.215,12.061c-34.555,19.919-48.993,62.365-33.751,99.223
               s55.442,56.709,93.973,46.405c38.531-10.304,63.456-47.571,58.266-87.117c-5.19-39.546-38.888-69.119-78.773-69.132
               c-4.875,0-8.828-3.952-8.828-8.828s3.952-8.828,8.828-8.828c53.629,0,97.103,43.475,97.103,97.103S309.629,353.103,256,353.103z"
               />
           <path fill="#FFFFFF" d="M279.392,203.034c-2.53,0.002-4.939-1.081-6.616-2.974l-23.388-26.431
               c-1.729-1.955-2.504-4.576-2.117-7.157c0.387-2.581,1.896-4.859,4.122-6.222l28.922-17.707c2.689-1.646,6.052-1.733,8.822-0.228
               c2.77,1.505,4.527,4.374,4.608,7.526c0.081,3.152-1.525,6.107-4.214,7.754l-19.944,12.216l16.414,18.543
               c2.301,2.601,2.864,6.309,1.439,9.475C286.014,200.996,282.865,203.033,279.392,203.034z"/>
       </g>
   </g>
   <g>
   </g>
   <g>
   </g>
   <g>
   </g>
   <g>
   </g>
   <g>
   </g>
   <g>
   </g>
   <g>
   </g>
   <g>
   </g>
   <g>
   </g>
   <g>
   </g>
   <g>
   </g>
   <g>
   </g>
   <g>
   </g>
   <g>
   </g>
   <g>
   </g>
   </svg>
    );
};

export default DeleteIcon;

